import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { PriceListUerRatioRow } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { RatioRowsWithScopesSelectorCheckboxRenderer } from '../components/RatioRowsWithScopesSelectorCheckboxRenderer';

import {
    uerPriceListUerRatioRowsCodeFilterGql,
    uerPriceListUerRatioRowsNameFilterGql,
} from './priceListRatioRowsWithScopesQueries';

interface IUseUerPriceListRatioRowsWithScopesColumns {
    checkedIds: number[];
    onCheckChange: (checkedIds: number[]) => void;
    uerBaseRowId: number;
    contractId: number;
    changeFilterHandler: ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => void;
}

export const useUerPriceListRatioRowsWithScopesColumns = (props: IUseUerPriceListRatioRowsWithScopesColumns) => {
    const { checkedIds, onCheckChange, contractId, uerBaseRowId, changeFilterHandler } = props;

    const filterVariables = useMemo(
        () => ({
            uerBaseRowId,
            contractId,
        }),
        [contractId, uerBaseRowId],
    );

    return useMemo<ColDef<PriceListUerRatioRow>[]>(
        () => [
            {
                field: '' as any,
                width: 60,
                cellRenderer: RatioRowsWithScopesSelectorCheckboxRenderer,
                cellRendererParams: {
                    checkedIds,
                    onCheckChange,
                },
            },
            {
                field: 'code',
                headerName: 'Шифр',
                width: 110,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables: filterVariables,
                    changeFilterHandler,
                    dataAccessor: 'uerPriceListUerRatioRowsCodeFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Шифр',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerPriceListUerRatioRowsCodeFilterGql,
                },
            },
            {
                field: 'workConditions',
                headerName: 'Наименование',
                flex: 1,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    variables: filterVariables,
                    changeFilterHandler,
                    dataAccessor: 'uerPriceListUerRatioRowsNameFilter',
                    whereVariables: ['value'],
                    childFieldAccessor: 'value',
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'value',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    query: uerPriceListUerRatioRowsNameFilterGql,
                },
            },
        ],
        [changeFilterHandler, checkedIds, onCheckChange, filterVariables],
    );
};
